var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-3 text-right"},[_c('DropdownMenu',{attrs:{"disabled":_vm.disabled,"menuItems":_vm.menuItems,"label":"Actions"},on:{"add-unit":_vm.addUnits,"download-existing":_vm.downloadExisting,"download-template":_vm.downloadTemplate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }